import React from 'react'

const Dish: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/dish.svg" alt="dish"/>
  )
}

export default Dish